import React, { useEffect } from 'react';
import {
  StreamingAgentMessageType,
  // ToolResultBlock,
  useChatStore,
} from '../store/chatStore';
import { useWebSocketStore } from '../../../store/websocketStore';
import { WebSocketConnection } from '../../WebSocket/WebSocketConnection';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { PleriClient } from '../client';
import { UniversalDashboardRenderer } from '../../../dashboard/components/common/UniversalDashboardRenderer';
// import { safeJsonParse } from '../../../utils/jsonRepairUtils';
import { SimpleDashboardConfig } from '../../../dashboard/components/Dashboard';

/**
 *
 * Handles special user interactions for streaming messages like dashboard opening, focusing etc
 */
const streamEventHandler = (
  message: StreamingAgentMessageType,
  _queryClient: QueryClient,
) => {
  if (message.type === 'streaming') {
    if (message.content.type === 'toolUse') {
      if (message.content.name === 'GetDashboard') {
        PleriClient.updateChatInput({
          useExistingConversation: true,
          focusedView: {
            content: (
              <UniversalDashboardRenderer
                dashboardId={message.content.input?.dashboardId as string}
                variant="full"
              />
            ),
            title: message.content.input?.dashboardTitle as string,
            printMode: 'image',
          },
        });
      } else if (message.content.name === 'ManageDashboard') {
        PleriClient.updateChatInput({
          useExistingConversation: true,
          focusedView: {
            content: (
              <UniversalDashboardRenderer
                config={
                  message.content.input
                    ?.dashboardSchema as SimpleDashboardConfig
                }
                variant="full"
                enableScaling
                showAskPleri={false}
              />
            ),
            printMode: 'image',
            title: (
              message.content.input?.dashboardSchema as SimpleDashboardConfig
            )?.title as string,
          },
        });
      }
    }
  }
  // if (message.type === 'toolResult') {
  //   const content = message.toolResult as ToolResultBlock[];
  //   content.forEach((result) => {
  //     if (result.toolName === 'ManageDashboard') {
  //       const parsedContent = safeJsonParse(result.content as string) as {
  //         dashboardId: string;
  //         dashboardTitle: string;
  //       };
  //       if (parsedContent) {
  //         // Invalidate dashboard queries to ensure fresh data
  //         queryClient.refetchQueries({
  //           queryKey: ['dashboard', parsedContent.dashboardId],
  //         });

  //         PleriClient.updateChatInput({
  //           useExistingConversation: true,
  //           focusedView: {
  //             content: (
  //               <UniversalDashboardRenderer
  //                 dashboardId={parsedContent.dashboardId}
  //                 variant="full"
  //                 enablePDF
  //                 enableScreenshot
  //                 enableScaling
  //                 showAskPleri={false}
  //               />
  //             ),
  //           },
  //         });
  //       }
  //     }
  //   });
  // }
};

export const PleriMessageStreamListener = () => {
  // Add message handling setup
  const handleIncomingMessage = useChatStore(
    (state) => state.handleIncomingMessage,
  );
  const lastMessage = useWebSocketStore(
    (state) => state.lastMessage as StreamingAgentMessageType,
  );
  const queryClient = useQueryClient();

  // Handle incoming messages
  useEffect(() => {
    if (lastMessage) {
      handleIncomingMessage(lastMessage, queryClient);
      streamEventHandler(lastMessage, queryClient);
    }
  }, [lastMessage, handleIncomingMessage, queryClient]);
  return <WebSocketConnection />;
};
